import React from "react";
import { Card, Container, Row, Col, Alert } from "react-bootstrap";

const Home: React.FC = () => {
  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8}>
          <div className="welcome-container">
            <h1 className="display-4 mb-4">
              Bienvenido a Demo Azure AD
            </h1>

            <Card className="text-center">
              <Card.Body>
                <Card.Title className="mb-3">
                  Aplicación de Demostración con Azure Active Directory
                </Card.Title>
                <Card.Text className="mb-4">
                  Esta aplicación demuestra la integración con Azure Active
                  Directory usando MSAL (Microsoft Authentication Library) para
                  React.
                </Card.Text>

                <Alert variant="info" className="mb-4">
                  <h5>Características principales:</h5>
                  <ul className="list-unstyled mt-2">
                    <li>✅ Autenticación con Azure AD</li>
                    <li>✅ Login/Logout con popup y redirect</li>
                    <li>✅ Acceso a Microsoft Graph API</li>
                    <li>✅ Información del perfil de usuario</li>
                    <li>✅ Navegación protegida por autenticación</li>
                    <li>✅ TypeScript para seguridad de tipos</li>
                  </ul>
                </Alert>

                <p className="text-muted">
                  Para comenzar, inicia sesión con tu cuenta de Azure Active
                  Directory usando el botón en la barra de navegación
                  superior.
                </p>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Home;
